// Valores por defecto de tipsPrudenceSga.
export const defaultTipsPrudenceSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultActionTipPrudence = () => {
    return "";
};

// Valor por defecto de tipPrudence.
export const defaultTipPrudence = () => {
    return {
        id: null,
        name: null,
        code: null,
        prudence_tip_type_id: null,
        sga_prudence_tip_code_languages: [],
        parent_prudence_tip_code_ids: [],
    };
};

// Valores por defecto de filterTipsPrudenceSga.
export const defaultFilterTipsPrudenceSga = () => {
    return {
        name: null,
        is_active: null,
        prudence_tip_type_id: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activeTipsPrudenceSga.
export const defaultActiveTipsPrudenceSga = () => {
    return [];
};

export default {
    tipsPrudenceSga: defaultTipsPrudenceSga(),
    action: defaultActionTipPrudence(),
    tipPrudence: defaultTipPrudence(),
    filterTipsPrudenceSga: defaultFilterTipsPrudenceSga(),
    activeTipsPrudenceSga: defaultActiveTipsPrudenceSga(),
};
